"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUgcCarouselData = void 0;
var graphql_request_1 = require("graphql-request");
var shopify_1 = require("../shopify-graphql/shopify");
var getUgcCarouselData = function (handle, pathType) { return __awaiter(void 0, void 0, void 0, function () {
    var variables, UGC_FRAGMENT, query, collection, reference, UGC_FRAGMENT, query, product, reference, UGC_FRAGMENT, query, page, reference;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                variables = {
                    handle: handle,
                };
                if (!(pathType === 'Collection')) return [3 /*break*/, 2];
                UGC_FRAGMENT = "\n        fragment ugcValues on Collection {\n          metafield(key: \"ugc_carousel_data\", namespace: \"global\") {\n            reference {\n              ... on Metaobject {\n                field(key: \"data\") {\n                  value\n                }\n              }\n            }\n          }\n        }\n      ";
                query = (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query getUgcData($handle: String!) {\n        collection(handle: $handle) {\n          ...ugcValues\n        }\n      }\n\n      ", "\n    "], ["\n      query getUgcData($handle: String!) {\n        collection(handle: $handle) {\n          ...ugcValues\n        }\n      }\n\n      ", "\n    "])), UGC_FRAGMENT);
                return [4 /*yield*/, (0, shopify_1.default)(query, variables)];
            case 1:
                collection = (_d.sent()).collection;
                if (!((_a = collection.metafield) === null || _a === void 0 ? void 0 : _a.reference)) {
                    console.error("Shopify Metafield Error: provided collection is missing 'ugc_carousel_data' metafield in Shopify admin.", 'collection: ', collection);
                    throw new Error('');
                }
                reference = collection.metafield.reference;
                return [2 /*return*/, reference.field];
            case 2:
                if (!(pathType === 'Product')) return [3 /*break*/, 4];
                UGC_FRAGMENT = "\n        fragment UgcValues on Product {\n          metafield(key: \"ugc_carousel_data\", namespace: \"global\") {\n            reference {\n              ... on Metaobject {\n                field(key: \"data\") {\n                  value\n                }\n              }\n            }\n          }\n        }\n      ";
                query = (0, graphql_request_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      query getUgcData($handle: String!) {\n        product(handle: $handle) {\n          ...UgcValues\n        }\n      }\n\n      ", "\n    "], ["\n      query getUgcData($handle: String!) {\n        product(handle: $handle) {\n          ...UgcValues\n        }\n      }\n\n      ", "\n    "])), UGC_FRAGMENT);
                return [4 /*yield*/, (0, shopify_1.default)(query, variables)];
            case 3:
                product = (_d.sent()).product;
                if (!((_b = product.metafield) === null || _b === void 0 ? void 0 : _b.reference)) {
                    console.error("Shopify Metafield Error: provided product is missing 'ugc_carousel_data' metafield in Shopify admin.", 'product: ', product);
                    throw new Error('');
                }
                reference = product.metafield.reference;
                return [2 /*return*/, reference.field];
            case 4:
                if (!(pathType === 'Page')) return [3 /*break*/, 6];
                UGC_FRAGMENT = "\n        fragment UgcValues on Page {\n          metafield(key: \"ugc_carousel_data\", namespace: \"global\") {\n            reference {\n              ... on Metaobject {\n                field(key: \"data\") {\n                  value\n                }\n              }\n            }\n          }\n        }\n      ";
                query = (0, graphql_request_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      query getUGCData($handle: String!) {\n        page(handle: $handle) {\n          ...UgcValues\n        }\n      }\n\n      ", "\n    "], ["\n      query getUGCData($handle: String!) {\n        page(handle: $handle) {\n          ...UgcValues\n        }\n      }\n\n      ", "\n    "])), UGC_FRAGMENT);
                return [4 /*yield*/, (0, shopify_1.default)(query, variables)];
            case 5:
                page = (_d.sent()).page;
                if (!((_c = page.metafield) === null || _c === void 0 ? void 0 : _c.reference)) {
                    console.error("Shopify Metafield Error: provided page is missing 'ugc_carousel_data metafield in Shopify admin.", 'page: ', page);
                    throw new Error('');
                }
                reference = page.metafield.reference;
                return [2 /*return*/, reference.field];
            case 6: return [2 /*return*/, null];
        }
    });
}); };
exports.getUgcCarouselData = getUgcCarouselData;
var templateObject_1, templateObject_2, templateObject_3;
